import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/CustomMods.css';

function CustomModsSection() {
  const { t } = useTranslation();
  const mods = [
    { imageUrl: '/data/images/custom/hh_patrolHelicopter.jpg' },
    { imageUrl: '/data/images/custom/podpivas_convoy.jpg' },
    { imageUrl: '/data/images/custom/armadayz_koth.jpg' },
    { imageUrl: '/data/images/custom/betrayal_armStamina.jpg' },
    { imageUrl: '/data/images/custom/betrayal_printer.jpg' },
    { imageUrl: '/data/images/custom/bandofbrothers_hackablecrates.jpg' },
    { imageUrl: '/data/images/custom/project_casino.jpg' },
    { imageUrl: '/data/images/custom/podpivas_donate.jpg' },
    { imageUrl: '/data/images/custom/kod_mining.jpg' },
    { imageUrl: '/data/images/custom/podpivas_codelock.jpg' },
    { imageUrl: '/data/images/custom/tigr.jpg' },
    { imageUrl: '/data/images/custom/borealis.jpg' },
    { imageUrl: '/data/images/custom/project_3dPrinter.jpg' },
  ];

  return (
    <section className="custom-mods-section">
      <h2>{t('CustomMods-h2')}</h2>
      <p>{t('CustomMods-p')}</p>
      <div className="mods-grid">
        {mods.map((mod, index) => (
          <div key={index} className="mod-item">
            <img src={mod.imageUrl} alt="modImage"/>
          </div>
        ))}
      </div>
    </section>
  );
}

export default CustomModsSection;